import React, { useState, useEffect } from "react"
import Layout from '../../components/layouts'
import SEO from '../../components/common/SEO'




function IndexVerify() {

   
    const seo = {
        title: "Workhub | What is Workhub? | Free EHS Management Software",
        description:
            "Workhub offers an all-in-one EHS Management Software with over 60+ training courses and tools to manage certificate tracking, policies, workplace screening, inspections, incident reporting, safety meetings and plenty more.",
    }


    return (
        <Layout>
            <SEO {...seo} />
            <div  style={{display:'flex', flexDirection:'column', gap:10+'px', justifyContent:'center', alignItems:'center', width:100 +'%', padding: 120+'px',}}>
                <div style={{display:'flex', flexDirection:'column', gap:10+'px',padding:40 +'px', border:1+'px' +' solid', borderRadius: 16 +'px'}}>
                        Business Profile Contact for Workhub Software Corp: 
                        <br></br>
                        <a href="mailto:ed.ferris@workhub.com">ed.ferris@workhub.com</a>
                    </div>
            </div>
           
        </Layout>
    )
}

export default IndexVerify